import { render, staticRenderFns } from "./single.vue?vue&type=template&id=56b87c82&scoped=true&"
import script from "./single.js?vue&type=script&lang=js&"
export * from "./single.js?vue&type=script&lang=js&"
import style0 from "./single.css?vue&type=style&index=0&id=56b87c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b87c82",
  null
  
)

export default component.exports